// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LOGIN_BUTTON = "Prihl\u00e1s ma";
export const LOGIN_I_FORGOT_PASSWORD = "Zabudla som heslo.";
export const LOGIN_NOT_REGISTERED_YET_THEN_url = "E\u0161te nem\u00e1\u0161 login a heslo? %(url)s";
export const LOGIN_PASSWORD = "Heslo:";
export const LOGIN_REGISTER_HERE = "Zaregistruj sa tu zadarmo!";
export const LOGIN_USERNAME_OR_EMAIL = "Prihlasovacie meno alebo email:";
export const LOGIN_YOU_DID_NOT_ENTER_PASSWORD = "Nezadala si heslo.";
export const LOGIN_YOU_DID_NOT_ENTER_USERNAME = "Nezadala si prihlasovacie meno alebo email.";
